import {apolloClient} from '@/setup/apollo-setup';
import {getField, updateField} from 'vuex-map-fields';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';

import {
  ADD_CLASSROOMTYPE,
  DELETE_CLASSROOMTYPE,
  GET_CLASSROOMTYPES,
  GET_CLASSROOMTYPE,
  UPDATE_CLASSROOMTYPE,
} from '@/queries/modules/class-room/classRoomType';

//
// initial state
const state = {
  classRoomType: {
    id: '',
    capacity: null,
    nameLocal: '',
    nameEng: '',
  },
  classRoomTypes: [],
  processing: false,
  error: null,
  success: null,
};

//
// getters
const getters = {
  getField
};

//
// mutations
const mutations = {
  updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
  setClassRoomTypes: (state, payload) => {
    state.classRoomTypes = payload ? payload : [];
  },
  setClassRoomType: (state, payload) => {
    state.classRoomType = payload;
  },
  setSelectedClassRoomType: (state, payload) => {
    state.classRoomType = {...payload};
  },
  clearSelectedClassRoomType: (state) => {
    state.classRoomType = {
      id: '',
      capacity: null,
      nameLocal: '',
      nameEng: '',
    }
  }
};

//
// actions
const actions = {
  getClassRoomTypes: async ({commit}) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_CLASSROOMTYPES,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        commit('setClassRoomTypes', data.getClassRoomTypes);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  getClassRoomType: async ({commit}, id) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_CLASSROOMTYPE,
        variables: {
          id: id
        },
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        commit('setClassRoomType', data.getClassRoomType);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  addClassRoomType: async ({commit}, payload) => {
    commit('setProcessing', true);
    await apolloClient
      .mutate({
        mutation: ADD_CLASSROOMTYPE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const classRoomTypes = [...state.classRoomTypes];
        classRoomTypes.push(data.addClassRoomType);
        commit('setClassRoomTypes', classRoomTypes);
        commit('setSuccess', newItemSuccess(data.addClassRoomType.nameLocal));
      })
      .catch((err) => {
        commit('setError', error(err));
      });
  },
  updateClassRoomType: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: UPDATE_CLASSROOMTYPE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const index = state.classRoomTypes.findIndex(classRoomType => classRoomType.id === data.updateClassRoomType.id);
        const classRoomTypes = [
          ...state.classRoomTypes.slice(0, index),
          data.updateClassRoomType,
          ...state.classRoomTypes.slice(index + 1)
        ];

        commit('setClassRoomTypes', classRoomTypes);
        commit('setSuccess', updateItemSuccess(data.updateClassRoomType.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  deleteClassRoomType: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: DELETE_CLASSROOMTYPE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const index = state.classRoomTypes.findIndex(classRoomType => classRoomType.id === data.deleteClassRoomType.id);
        const classRoomTypes = [
          ...state.classRoomTypes.slice(0, index),
          ...state.classRoomTypes.slice(index + 1)
        ];

        commit('setClassRoomTypes', classRoomTypes);
        commit('setSuccess', deleteItemSuccess(data.deleteClassRoomType.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  selectedClassRoomType: async ({commit}, payload) => {
    commit('setSelectedClassRoomType', payload);
  },
  clearSelectedClassRoomType: async ({commit}) => {
    commit('clearSelectedClassRoomType');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
